<template>
  <div class="animated-bg" :style="backgroundStyle">
    <transition name="fade">
      <div v-if="showContent" class="content-wrapper">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AnimatedBackground',
  props: {
    image: {
      type: String,
      default: require('@/assets/Tegning Christian.jpg')
    },
    zoomDuration: {
      type: Number,
      default: 800 // ms
    },
    initialScale: {
      type: Number,
      default: 1 // Start at normal size
    },
    finalScale: {
      type: Number,
      default: 3 // Zoom in further
    },
    focusPoints: {
      type: Array,
      default: () => [
        { x: 65, y: 68 },
        { x: 72, y: 60 },
        { x: 80, y: 72 },
        { x: 88, y: 64 },
        { x: 75, y: 82 }
      ]
    }
  },
  data() {
    return {
      bgX: 50,
      bgY: 50,
      scale: this.initialScale,
      showContent: false,
      lastFocusIndex: null
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url('${this.image}')`,
        backgroundPosition: `${this.bgX}% ${this.bgY}%`,
        backgroundSize: `${this.scale * 100}%`,
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        width: '100%',
        transition: `background-position 0.8s cubic-bezier(.4,0,.2,1), background-size 0.8s cubic-bezier(.4,0,.2,1)`
      }
    }
  },
  methods: {
    pickRandomFocusPoint(excludeIndex = null) {
      const validPoints = Array.isArray(this.focusPoints)
        ? this.focusPoints.filter(point => typeof point?.x === 'number' && typeof point?.y === 'number')
        : []

      if (!validPoints.length) {
        return {
          point: {
            x: Math.floor(Math.random() * 100),
            y: Math.floor(Math.random() * 100)
          },
          index: null
        }
      }

      if (validPoints.length === 1) {
        return { point: validPoints[0], index: 0 }
      }

      const indices = validPoints.map((_, idx) => idx)
      const availableIndices = excludeIndex === null
        ? indices
        : indices.filter(idx => idx !== excludeIndex)
      const index = availableIndices[Math.floor(Math.random() * availableIndices.length)]

      return { point: validPoints[index], index }
    }
  },
  mounted() {
    const { point, index } = this.pickRandomFocusPoint()
    this.bgX = point.x
    this.bgY = point.y
    this.scale = this.initialScale
    this.lastFocusIndex = index

    // Animate to zoom in and shift to a new area with content
    setTimeout(() => {
      this.scale = this.finalScale
      const next = this.pickRandomFocusPoint(this.lastFocusIndex)
      this.bgX = next.point.x
      this.bgY = next.point.y
      this.lastFocusIndex = next.index
    }, 50)

    // Show content after the zoom animation
    setTimeout(() => {
      this.showContent = true
    }, this.zoomDuration)
  }
}
</script>

<style scoped>
.animated-bg {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.content-wrapper {
  position: relative;
  z-index: 2;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style> 
